import { Ionicons } from '@expo/vector-icons';
import * as MailComposer from 'expo-mail-composer';
import { FlatList, Linking, Platform, StyleSheet, TouchableOpacity, View } from 'react-native';
import { Divider } from 'react-native-paper';
import { SafeAreaView } from 'react-native-safe-area-context';
import Toast from 'react-native-toast-message';

import { BS_CONTACT_EMAIL } from '@/constants/config';
import { useAuth } from '@/contexts/authContext';
import { i18n } from '@/utils/i18n';

import ExplanationCard from '../lightRating/ExplanationCard';
import Text from '../Text';

interface LightRatingExplanationBottomSheetProps {
  onCloseTap: () => void;
}

// Deprecated page
const LightRatingExplanationBottomSheet = ({ onCloseTap }: LightRatingExplanationBottomSheetProps) => {
  const { state } = useAuth();

  // Strings
  const lightRating = i18n.t('mix.light_rating');
  const contactUs = i18n.t('mix.contact_us');
  const subtitle = i18n.t('light_rating_explanation.subtitle');
  const additionalQuestions = i18n.t('light_rating_explanation.additional_questions');

  const content = () => (
    <View style={styles.mainContainer}>
      <View style={styles.headerSection}>
        <View style={styles.header}>
          <TouchableOpacity onPress={onCloseTap} style={styles.closeButton}>
            <Ionicons size={24} name="close" style={styles.closeIcon} />
          </TouchableOpacity>

          <Text style={styles.headerTitle}>{lightRating}</Text>
        </View>

        <Divider />
      </View>

      <View style={styles.content}>
        <ExplanationCard />

        <Text fontWeight="700" style={styles.boldText}>
          {subtitle}
        </Text>

        <FlatList
          data={[
            { id: '1', label: 'Accuracy with your accounting.' },
            { id: '2', label: 'Accuracy with your accounting.' },
            { id: '3', label: 'Accuracy with your accounting.' },
            { id: '4', label: 'Accuracy with your accounting.' },
            { id: '5', label: 'Accuracy with your accounting.' },
            { id: '6', label: 'Accuracy with your accounting.' },
            { id: '7', label: 'Accuracy with your accounting.' },
            { id: '8', label: 'Accuracy with your accounting.' }
          ]}
          keyExtractor={(item) => item.id}
          renderItem={({ item }) => {
            return <Text style={styles.bulletList}>{`\u2022 ${item.label}`}</Text>;
          }}
        />

        <Text fontWeight="700" style={styles.boldText}>
          {additionalQuestions}
        </Text>

        <TouchableOpacity
          onPress={() => {
            // ToDO: Change for actual support email data
            if (Platform.OS === 'web') {
              Linking.openURL(
                `mailto:${BS_CONTACT_EMAIL}?subject=Support - Broken Shepherds™ # ${state.user?.user?.fullName}&body=Hi my name is ${state.user?.user?.fullName} i need help with...`
              );
            } else {
              try {
                MailComposer.composeAsync({
                  recipients: [BS_CONTACT_EMAIL],
                  subject: `Support - Broken Shepherds™ # ${state.user?.user?.fullName}`,
                  body: `Hi my name is ${state.user?.user?.fullName} i need help with...`
                });
              } catch (e) {
                console.error(e);
                Toast.show({
                  type: 'error',
                  text1: i18n.t('mix.mail_not_openned.title'),
                  text2: i18n.t('mix.mail_not_openned.message'),
                  position: 'bottom',
                  visibilityTime: 3500
                });
              }
            }
          }}>
          <Text fontWeight="700" style={styles.contactUs}>
            {contactUs}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );

  if (Platform.OS === 'android') {
    return <SafeAreaView style={styles.mainContainer}>{content()}</SafeAreaView>;
  } else {
    return content();
  }
};

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1
  },

  headerSection: {
    flexDirection: 'column',
    justifyContent: 'center',
    paddingHorizontal: 18,
    paddingTop: 25
  },

  header: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 15
  },

  headerTitle: {
    fontSize: 20,
    color: 'black',
    fontWeight: '700'
  },

  closeButton: {
    position: 'absolute',
    left: 0,
    top: 0
  },

  closeIcon: {
    color: 'black',
    backgroundColor: '#F4F4F4',
    borderWidth: 1,
    borderColor: '#EDEDED',
    borderRadius: 26 / 2,
    overflow: 'hidden'
  },

  content: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 25,
    paddingHorizontal: 18,
    paddingVertical: 25
  },

  bulletList: {
    fontSize: 14,
    marginBottom: 5
  },

  boldText: {
    color: 'black',
    fontSize: 14
  },

  contactUs: {
    color: '#BB822D',
    fontSize: 14
  }
});

export default LightRatingExplanationBottomSheet;
